import React from 'react';

import PropTypes from 'prop-types';

import styled, { css } from 'styled-components';

const theme = {
    fullWidth: css`
        max-width: 100%;
        vertical-align: top;
    `,
};

const Image = styled.img`
    ${({ size }) => size === 'fullWidth' && theme.fullWidth};
`;
const IconSvgWidth = (props) => {
    return props.img && <Image size={props.size} src={props.img?.url} alt={props.img?.alternativeText} height={props.height} width={props.width} />;
};
const IconSvgNoWidth = (props) => {
    return props.img && <Image size={props.size} src={props.img?.url} alt={props.img?.alternativeText} height={props.img?.height} width={props.img?.width} />;
};

const IconSvg = (props) => {
    return props.width ? (
        <IconSvgWidth img={props.img} width={props.width} height={props.height} />
    ) : (
        <IconSvgNoWidth img={props.img} width={props.width} height={props.height} />
    );
};
IconSvg.propTypes = {
    img: PropTypes.object,
    height: PropTypes.string,
    width: PropTypes.string,
};
export default IconSvg;
